import Cookies from 'js-cookie';

const KEY_USER_TOKEN = 'token';
const KEY_USER_INFO = 'user';

export default class Permission {
  static isLogin() {
    return !!Permission.getUserToken();
  }

  static getUserToken() {
    return localStorage.getItem(KEY_USER_TOKEN);
  }

  static getUserInfo() {
    return JSON.parse(localStorage.getItem(KEY_USER_INFO));
  }

  static login() {
    const loginPath = process.env.VUE_APP_UNICLOUD_LOGIN_PATH;
    const redirectPath = process.env.VUE_APP_UNICLOUD_ROOT_PATH;

    // 固定跳回项目首页
    location.href = `${loginPath}?url=${redirectPath}`;
    return;
  }

  static logout() {
    localStorage.removeItem(KEY_USER_TOKEN);
    localStorage.removeItem(KEY_USER_INFO);

    // @FIXME@ZY: 想办法优化一下这部分
    sessionStorage.removeItem('logType');
    sessionStorage.removeItem('step');
    sessionStorage.removeItem('projectData');
    sessionStorage.removeItem('logData');
    sessionStorage.removeItem('accessConfigData');
    sessionStorage.removeItem('analyzeData');
    sessionStorage.removeItem('commonAnalyzeData');
    sessionStorage.removeItem('analyzeKeys');

    // 清空 kibana 的 cookie
    Cookies.remove('sid', { path: '/app/log-kibana/' });
    Cookies.remove('sid');

    location.href = '/';
  }
}
